module.exports = __webpack_public_path__ + "img/roktoyaugust20-2022.95881b74.jpg";